import React from 'react';
import { m } from 'framer-motion';
// @mui
import { styled } from '@mui/material/styles';
import { Typography, Container } from '@mui/material';
// components
import { MotionContainer, varBounce } from '../components/animate';
// assets
import { ForbiddenIllustration } from '../assets';
const ComponentForbidden = () => {
  const ContentStyle = styled('div')(({ theme }) => ({
    maxWidth: 480,
    margin: 'auto',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: theme.spacing(10, 0),
  }));
  return (
    <Container component={MotionContainer}>
      <ContentStyle sx={{ textAlign: 'center', alignItems: 'center' }}>
        <m.div variants={varBounce().in}>
          <Typography variant="h3" paragraph>
            Sin Permisos
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <Typography sx={{ color: 'text.secondary' }}>
            La sección que intentas acceder tiene acceso restringido.
            <br />
            Por favor intenta comunicarte con tu administrador
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <ForbiddenIllustration
            sx={{ height: 260, mt: { xs: 5, sm: 10 }, mb: 1 }}
          />
        </m.div>
      </ContentStyle>
    </Container>
  );
};

export default ComponentForbidden;
